import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import {
  GET_EMPLOYEECONTRACT,
  DELETE_EMPLOYEECONTRACT,
  UPDATE_EMPLOYEECONTRACT,
  ADD_NEW_EMPLOYEECONTRACT,
} from "./actionType";

import {
  getEmployeeContractSuccess,
  getEmployeeContractFail,
  deleteEmployeeContractSuccess,
  deleteEmployeeContractFail,
  updateEmployeeContractSuccess,
  updateEmployeeContractFail,
  addEmployeeContractSuccess,
  addEmployeeContractFail,
} from "./action";

//Include Both Helper File with needed methods
import {
  approveEmployeeContractApi,
  getEmployeeContractApi,
  updateEmployeeContractApi,
  deleteEmployeeContractApi,
  addNewEmployeeContractApi
} from "../../helpers/backend_helper";

function* getEmployeeContract({ payload: employeeContract }) {
  try {
    const response = yield call(getEmployeeContractApi, employeeContract);
    yield put(getEmployeeContractSuccess(GET_EMPLOYEECONTRACT, response.data));
  } catch (error) {
    yield put(getEmployeeContractFail(GET_EMPLOYEECONTRACT, error));
  }
}

function* onUpdateEmployeeContract({ payload: employeeContract }) {
  try {
    if (employeeContract.setApprove) {
      const response = yield call(approveEmployeeContractApi, employeeContract);
      yield put(updateEmployeeContractSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }
    else {
      const response = yield call(updateEmployeeContractApi, employeeContract);
      yield put(updateEmployeeContractSuccess(response));
      toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
    }

  } catch (error) {
    yield put(updateEmployeeContractFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onDeleteEmployeeContract({ payload: employeeContract }) {
  try {
    const response = yield call(deleteEmployeeContractApi, employeeContract);
    yield put(deleteEmployeeContractSuccess({ employeeContract, ...response }));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(deleteEmployeeContractFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }
}

function* onAddNewEmployeeContract({ payload: employeeContract }) {
  try {
    const response = yield call(addNewEmployeeContractApi, employeeContract);
    yield put(addEmployeeContractSuccess(response));
    toast.success(response.message, { position: "bottom-left", autoClose: 3000 });
  } catch (error) {
    yield put(addEmployeeContractFail(error));
    toast.error(error.response.data.message, { position: "bottom-left", autoClose: 3000 });
  }

}

export function* watchGetEmployeeContract() {
  yield takeEvery(GET_EMPLOYEECONTRACT, getEmployeeContract);
}

export function* watchUpdateEmployeeContract() {
  yield takeEvery(UPDATE_EMPLOYEECONTRACT, onUpdateEmployeeContract);
}

export function* watchDeleteEmployeeContract() {
  yield takeEvery(DELETE_EMPLOYEECONTRACT, onDeleteEmployeeContract);
}

export function* watchAddNewEmployeeContract() {
  yield takeEvery(ADD_NEW_EMPLOYEECONTRACT, onAddNewEmployeeContract);
}

function* employeeContractSaga() {
  yield all([
    fork(watchGetEmployeeContract),
    fork(watchDeleteEmployeeContract),
    fork(watchUpdateEmployeeContract),
    fork(watchAddNewEmployeeContract)
  ]);
}

export default employeeContractSaga;
